import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import SvgSymbol from 'common/components/svg-symbol';

import {t} from 'common/utils/translation-util';
import './index.scss';

const ZeroStateCard = ({buttonTitle, buttonClass, message, onButtonClick}) => {
  return (
    <div className={'ZeroStateCard'}>
      <SvgSymbol
        className={'ZeroStateCard--Image'}
        name={'zeroState-dashboards'}
      />
      <p className={'ZeroStateCard--Text'}>{message}</p>
      <Button
        className={buttonClass}
        onClick={onButtonClick}
        type={'green'}
        withIcon={true}>
        {buttonTitle}
      </Button>
    </div>
  );
};

ZeroStateCard.propTypes = {
  buttonClass: PropTypes.string,
  buttonTitle: PropTypes.string,
  message: PropTypes.string,
  onButtonClick: PropTypes.func,
};

ZeroStateCard.defaultProps = {
  buttonClass: '',
  buttonTitle: t('Add a dashboard'),
  message: t('No dashboard found'),
  onButtonClick: () => null,
};

export default ZeroStateCard;
